<!--  -->
<template>
  <div>
    <NavBar />
    <div class="content-container">
      <div class="content-header">
        修改密码
      </div>
      <div
        class="pass-content"
        :style="'height:'+autoHeight+'px;'"
      >
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item
            label=" "
            prop="pass"
          >
            <el-input
              type="password"
              placeholder="请输入新密码"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=" "
            prop="pwd"
          >
            <el-input
              placeholder="请确认新密码"
              type="password"
              v-model="ruleForm.pwd"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=" "
            prop="code"
            class="email-content"
          >
            <el-input
              placeholder="请输入邮箱验证码"
              v-model.number="ruleForm.code"
            ></el-input>
            <el-button
              type="text"
              :class="isDisClick?'get-email dis-get':'get-email'"
              :disabled="isDisClick"
              @click="handleClick"
            >{{isDisClick?timeStr+'(s)后重试':'获取邮箱验证码'}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width:100%; height:40px !important; line-height:40px;"
              type="primary"
              @click="submitForm('ruleForm')"
            >保 存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/clearNavBar"
import { getEmailNumber, updatePassword, getAllInfo } from "@/api/siter.js"
import { removeStorage } from '@/utils/auth'
import md5 from 'js-md5'
export default {
  components: { NavBar },
  data () {
    var checkCode = (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {
        callback(new Error('请输入邮箱验证码'));
      } else {
        callback();
      }
    }
    var validatePass = (rule, value, callback) => {
      var re = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!re.exec(value)) {
        callback(new Error('8-20位密码，包含字母和数字'));
      } else {
        if (this.ruleForm.pwd !== '') {
          this.$refs.ruleForm.validateField('pwd');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var re = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (!re.exec(value)) {
        callback(new Error('8-20位密码，包含字母和数字'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userInfo: {},
      autoHeight: 840,
      timeStr: 60,
      isDisClick: false,
      ruleForm: {
        pass: '',
        pwd: '',
        code: ''
      },
      userId: null,

      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        pwd: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        code: [
          { validator: checkCode, trigger: 'blur' }
        ]
      }
    };
  },
  mounted () {
    const _this = this
    window.onresize = function () {
      _this.autoHeight = document.body.clientHeight - 160
    }
    this.getAllSiterInfo()
  },
  methods: {
    //获取流量主所有信息
    getAllSiterInfo () {
      getAllInfo({ trafficId: this.id }).then(res => {
        if (res.code == '0') {
          if (res.data.trafficUserNewVO) {
            this.userInfo = res.data.trafficUserNewVO
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePassword({ userId: this.userInfo.id, pwd: md5(this.ruleForm.pwd), code: this.ruleForm.code, isFlag: 1 }).then(res => {
            if (res.code == '0') {
              this.$message.success("密码修改成功，请退出重新登录系统")
              removeStorage('token')
              this.$router.push('/userCenter')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClick () {
      const _this = this
      _this.isDisClick = true
      getEmailNumber({ email: this.userInfo.email, isFlag: 1 }).then(res => {
        _this.timeStr = 60
        if (res.code == '0') {
          _this.$message.success("验证码已发送，请注意查收")
          window.timeInter = setInterval(function () {
            _this.timeStr = _this.timeStr - 1
            if (_this.timeStr <= 0) {
              _this.isDisClick = false
              clearInterval(window.timeInter)
            }
          }, 1000)
          timeInter()
        } else {
          _this.$message.error(res.msg)
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style lang='scss' scoped>
$iptHeight: 40px;
.content-container {
  border-radius: 10px;
  overflow: hidden;
  .content-header {
    text-align: center;
    height: 60px;
    background: #1c2b36;
    line-height: 60px;
    font-size: 22px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
  }
  .pass-content {
    background: #ffffff;
    text-align: center;
    .demo-ruleForm {
      width: 360px;
      margin: 0 auto;
      padding-top: 60px;
      .email-content {
        position: relative;
        .get-email {
          font-size: 14px;
          color: #13c2c2;
          top: 6px;
          position: absolute;
          right: 10px;
        }
        .dis-get {
          color: #cccccc;
        }
        .el-button {
          &:hover {
            border-color: #ffffff;
            background: #ffffff;
          }
        }
      }
      /deep/.el-input__inner {
        height: $iptHeight;
        line-height: $iptHeight;
      }
      /deep/.el-icon-arrow-up {
        height: $iptHeight !important;
      }
      /deep/.el-input__icon {
        line-height: $iptHeight;
      }
    }
  }
}
</style>